import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/discounts/voucher-type/:voucherTypeId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    voucherTypeId: string;
}
const mutationFn = ({ voucherTypeId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { voucherTypeId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteVoucherType };
